import React, { useState, useEffect } from "react";
import icon from "../../assets/images/lock_icon.png";
import { Navbar, Nav, Container, NavDropdown, Form, FormControl, Button, Modal } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";
import { useForm } from "react-hook-form";
import axios from "axios";
import { data } from "jquery";
import $ from 'jquery';
import LottieLoader from '../lottie/lottieloader';
import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";

function Moreabout() {
    const [otherlogin, setotherlogin] = useState(false);
    const [states, setStates] = useState([]);
    const [show, setShow] = useState(false)
    const [countrySelected, setCountrySelected] = useState(false)
    const [mstatus, setMstatus] = useState('');
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const Auth = process.env.REACT_APP_USER_TOKEN;
    const location = useLocation();
    const navigate = useNavigate();
    const { register, handleSubmit, resetField, formState: { errors }, setValue } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {},
    });
    const [details, setDetails] = useState([]);
    const [disable, setDisable] = useState(false);
    const [status, setStatus] = useState('');
    const [motherTongue, setmotherTongue] = useState([])
    const [selectedmotherTongue, setSelectedmotherTongue] = useState([])
    const [nation, setnation] = useState([])
    const [selectednation, setSelectednation] = useState([])
    const local_storage = JSON.parse(localStorage.getItem('userDetails'));
    var checkedValue = [];
    const onMoreSubmit = (data) => {
        setDisable(true)
        var inputElements = document.getElementsByClassName('getmore');
        for (var i = 0; inputElements[i]; ++i) {
            if (inputElements[i].checked) {
                checkedValue.push(inputElements[i].value);
            }
        }
        let newHobbies = checkedValue.join()
        const regFormData = new FormData();
        let key;
        if (location.state !== null) {
            regFormData.append('user_id', location.state.user_id);
            key = location.state.api_key;
        } else {
            regFormData.append('user_id', local_storage.user_id)
            key = local_storage.api_key;
        }

        function toastfunction(data) {
            Toastify({
                text: data,
                duration: 2000,
                newWindow: true,
                close: true,
                gravity: "top",
                position: "right",
                stopOnFocus: true,
                style: {
                    background: "linear-gradient(to right, #00b09b, #96c93d)",
                },
            }).showToast();

        }
        regFormData.append('marital_status', data.status);
        if (data.status == "") {
            toastfunction("Please select Marital Status");
            setDisable(false);
            return false;
        }
        regFormData.append('children_status', data.childYes);
        if (data.childYes == undefined) {
            toastfunction("Please Provide Children Status");
            setDisable(false);
            return false;
        }
        if (data.childYes == "") {
            toastfunction("Please Provide Children Status");
            setDisable(false);
            return false;
        }
        if (data.childYes == "1") {
            if (data.children == "") {
                toastfunction("Please Provide No Of Children");
                setDisable(false);
                return false;
            }
        }
        regFormData.append('children_count', data.children);
        regFormData.append('mother_tongue_id', data.tongue);
        if (data.tongue == "") {
            toastfunction("Please Select Language");
            setDisable(false);
            return false;
        }
        regFormData.append('nationality_id', selectednation.toString());
        if (selectednation == "") {
            toastfunction("Please Select Nationality");
            setDisable(false);
            return false;
        }
        regFormData.append('country_id', data.country);
        if (data.country == "") {
            toastfunction("Please Select Living In");
            setDisable(false);
            return false;
        }
        // if (data.state == "") {
        //     toastfunction("Please Select State");
        //     setDisable(false);
        //     return false;
        // }
        regFormData.append('state_id', data.state);
        regFormData.append('occupation_id', data.occupation);
        if (data.occupation == "") {
            toastfunction("Please Select Occupation");
            setDisable(false);
            return false;
        }
        regFormData.append('user_height', data.height);
        if (data.height == "") {
            toastfunction("Please Select height");
            setDisable(false);
            return false;
        }
        regFormData.append('user_weight', data.weight);
        if (data.weight == "") {
            toastfunction("Please Select weight");
            setDisable(false);
            return false;
        }
        regFormData.append('religion_id', data.religion);
        if (data.religion == "") {
            toastfunction("Please Select religion");
            setDisable(false);
            return false;
        }

        regFormData.append('education_id', data.education);
        regFormData.append('caste', data.caste);

        regFormData.append('smoke', data.smoke);
        if (data.smoke == "") {
            toastfunction("Please Select Smoke Habit");
            setDisable(false);
            return false;
        }
        regFormData.append('drink', data.drinks);
        if (data.drinks == "") {
            toastfunction("Please Select Drinking Habit");
            setDisable(false);
            return false;
        }

        regFormData.append('diet', data.diet);
        if (data.diet == "") {
            toastfunction("Please Select Diet");
            setDisable(false);
            return false;
        }
        regFormData.append('horoscope_id', data.horoscope);
        axios({
            method: 'POST',
            url: `${baseUrl}/Registration/set_more_about`,
            headers: {
                "Content-type": "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2),
                'X-api-key': key,
            },
            data: regFormData
        }).then((res) => {
            if (res.data.status === 1) {
                if (location.state == null) {
                    navigate('/settings')
                } else {
                    setTimeout(() => {
                        navigate('/hobbies', { state: location.state })
                    }, 3000);
                }
                Toastify({
                    text: res.data.message,
                    duration: 2000,
                    newWindow: true,
                    close: true,
                    gravity: "top",
                    position: "right",
                    stopOnFocus: true,
                    style: {
                        background: "linear-gradient(to right, #00b09b, #96c93d)",
                    },
                }).showToast();
            } else {
                setDisable(false);
                Toastify({
                    text: res.data.message,
                    duration: 2000,
                    newWindow: true,
                    close: true,
                    gravity: "top",
                    position: "right",
                    stopOnFocus: true,
                    style: {
                        background: "linear-gradient(to right, #00b09b, #96c93d)",
                    },
                }).showToast();
            }
        }).catch((e) => {
            console.log(e.response, 'e')
            setDisable(false)
            if (e.message == 'Request failed with status code 401') {
                setotherlogin(true)
            }
        })
    }
    const onMultipleSelectChangemt = (event) => {
        if (event.length > 5) {
            event.pop();
            alert("You can select upto 5 languages only")
            return false;
        }
        let coun = [];
        event.map((e) => {
            coun.push(e)
        })
        setSelectedmotherTongue(coun)
    };

    const onMultipleSelectChangenation = (event) => {
        if (event.length > 2) {
            event.pop();
            alert("You can select upto 2 Nationalities only")
            return false;
        }
        let coun = [];
        event.map((e) => {
            coun.push(e)
        })
        setSelectednation(coun);
    };
    const handleChild = (e) => {
        if (e.target.value === '1') {
            setShow(true)
        } else {
            setShow(false)
        }
    }
    const handleChange = (e) => {
        if (mstatus !== e.target.value) {
            resetField('childYes')
            resetField('children')
            setShow(false);
        }
        setMstatus(e.target.value);
    }
    const setSingleState = (country_id) => {
        const regFormData = new FormData();
        regFormData.append('country_id', country_id);
        let key;
        if (location.state !== null) {
            key = location.state.api_key;
        } else {
            key = local_storage.api_key;
        }
        axios({
            method: 'POST',
            url: `${baseUrl}/Registration/get_states`,
            headers: {
                "Content-type": "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2),
                'X-api-key': key,
            },
            data: regFormData
        }).then((res) => {
            setStates(res.data.data)
        }).catch((e) => {
            console.log(e.response, 'e')
            if (e.message == 'Request failed with status code 401') {
                setotherlogin(true)
            }
        })
    }
    const handleState = (e) => {
        if (e.target.value !== 1) {
            setSingleState(e.target.value)
            setCountrySelected(true);
        } else {
            document.getElementById('dstate').style.display = 'none';
            setCountrySelected(false);
        }
    }
    useEffect(() => {
        $(".progress-bar").animate({
            width: "85%"
        }, 2500);
        axios({
            method: 'GET',
            url: `${baseUrl}/Registration/get_more_about`,
            headers: {
                "Content-type": "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2),
                'X-api-key': Auth,
            }
        }).then((res) => {
            let dataa = [];
            dataa.push(res.data.data)
            let motherTongueData = [];
            let nationData = [];
            res.data.data.nationality.map((data, i) => {
                let othercoun = {};
                othercoun.key = data.nationality_id
                othercoun.label = data.nationality_name
                othercoun.value = data.nationality_name
                othercoun.disabled = false
                nationData.push(othercoun);
                let newSelectedmt = [];
                selectednation.map((data1) => {
                    if (data.nationality_id == data1) {
                        newSelectedmt.push(data1);
                        setSelectednation(newSelectedmt)
                    }
                })
            })
            setnation(nationData)
            setDetails(dataa)
        }).catch((e) => {
            console.log(e)
        })

        const getUserFormData = new FormData();
        let key;
        if (location.state !== null) {
            getUserFormData.append('user_id', location.state.user_id);
            key = location.state.api_key;
        } else {
            getUserFormData.append('user_id', local_storage.user_id)
            key = local_storage.api_key;
        }
        axios({
            method: 'POST',
            url: `${baseUrl}/Registration/get_more_about_me`,
            headers: {
                "Content-type": "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2),
                'X-api-key': key,
            },
            data: getUserFormData
        }).then((res) => {
            // console.log(res)
            if (res.data.status === 1) {
                setTimeout(() => {
                    setValue('tongue', res.data.data.mother_tongue_id)
                    setValue('nation', res.data.data.nationality_id)
                    setValue('occupation', res.data.data.occupation_id)
                    setValue('country', res.data.data.country_id)
                    if (res.data.data.country_id != 1) {
                        setCountrySelected(false)
                    } else {
                        setCountrySelected(true)
                    }
                    setValue('state', res.data.data.state_id)
                    setValue('height', res.data.data.user_height)
                    setValue('weight', res.data.data.user_weight)
                    setValue('religion', res.data.data.religion_id)
                    setValue('horoscope', res.data.data.horoscope_id)
                }, 300);
                res.data.data.country_id != '' && setSingleState(res.data.data.country_id)
                setValue('status', res.data.data.marital_status)
                setValue('childYes', res.data.data.children_status)
                setValue('children', res.data.data.children_count)
                setValue('education', res.data.data.education_id)
                setValue('religion', res.data.data.religion_id)
                setValue('caste', res.data.data.caste)
                setValue('smoke', res.data.data.smoke)
                setValue('drinks', res.data.data.drink)
                setValue('diet', res.data.data.diet)
                setValue('horoscope', res.data.data.horoscope_id)
                if (res.data.data.children_status != 0) {
                    setShow(true)
                } else {
                    setShow(false)
                }
                if (res.data.data.mother_tongue_id != "") {
                    setSelectedmotherTongue(res.data.data.mother_tongue_id.split(','));
                }
                if (res.data.data.nationality_id != "") {
                    setSelectednation(res.data.data.nationality_id.split(','));
                }
            }
        }).catch((error) => {
            console.log(error)
        })
    }, [])
    //console.log(details, 'mttt')
    return (
        <div className="d-lg-flex d-block">
            <Modal show={otherlogin} size="lg" animation={false} aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Body className="text-center">Sorry! Someone has logged in with your account.Please check and come back</Modal.Body>
                <Modal.Footer>
                    <Button onClick={(e) => navigate('/Login')} className="up-btn">
                        ok
                    </Button>
                </Modal.Footer>
            </Modal>
            {disable ? <div className='AddPetloadingImage'><LottieLoader /></div> : ''}
            <div className="col-6 moreabout_page"></div>
            <div className="col-lg-6 col-12 mt-5 content_login" style={{ height: '100vh', overflowY: 'auto' }}>
                <div className="col-xs-12 col-sm-12 progress-container">
                    <div className="progress progress-striped active">
                        <div className="progress-bar progress-bar-success" ></div>
                    </div>
                    {location.state !== null ? <Button variant="danger" onClick={() => navigate("/addphotos", { state: location.state })} className="back_button mt-3"><i className="fa fa-arrow-left">&nbsp; Back</i></Button> : ''}
                </div>
                <div className="text-center">
                    <img src={icon} />
                </div>
                <Form className="mt-4 px-lg-5 px-3">
                    <h3 className="text-center mb-4">More About Me</h3>
                    <label>Marital Status</label>
                    <div className="form-check px-0" id="activeweights" >
                        {details && details.length > 0 ? details[0].marital_status.map((data, i) => {
                            return (
                                <label className="custom-checkbox">
                                    <input {...register("status")} className="getmore custom-checkbox-input" value={data.id} type="radio" onClick={(e) => handleChange(e)} />
                                    <span className="custom-checkbox-text">{data.name}</span>
                                </label>
                            )
                        }) : ''}
                        <br></br>
                        <span className='error_msg'> {errors.status?.type === 'required' && "Please  select martial status"}</span>
                    </div>
                    {status !== '1' && <> <label className="mt-3">Children</label>
                        <div className="form-check px-0 d-flex" id="activeweights" >
                            <div className="col-4">
                                <label className="custom-checkbox">
                                    <input type="hidden" value="False" />
                                    <input {...register("childYes")} onClick={(e) => handleChild(e)} className="getmore custom-checkbox-input" value="1" type="radio" />
                                    <span className="custom-checkbox-text">Yes</span>
                                </label>
                                <label className="custom-checkbox">
                                    <input type="hidden" value="False" />
                                    <input {...register("childYes")} onClick={(e) => handleChild(e)} className="getmore custom-checkbox-input" value="0" type="radio" />
                                    <span className="custom-checkbox-text">No</span>
                                </label>
                            </div>
                            <span className='error_msg'> {errors.childYes?.type === 'required' && "Please select children"}</span>
                            {show ? <div className="col-4"><Form.Select {...register("children")} aria-label="Default select example" className="looking_dropdown col-2">
                                <option value="">How many</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                            </Form.Select></div> : ''}
                        </div>
                        <span className='error_msg'> {errors.children?.type === 'required' && "Please  select How many Children"}</span> </>}
                    <Form.Select  {...register("tongue")} className="looking_dropdown" required>
                        <option value="" disabled >Language</option>
                        {details && details.length > 0 ? details[0].mother_tongue.map((data, i) => {
                            // console.log(data)
                            if (data.mother_tongue_id != '57') {
                                return (
                                    <option value={data.mother_tongue_id} >{data.mother_tongue}</option>
                                )
                            }
                        }) : ''}
                    </Form.Select>

                    <div className="mt-3">
                        {nation && nation.length > 0 ? <DropdownMultiselect
                            selected={selectednation} handleOnChange={(e) => onMultipleSelectChangenation(e)}
                            className="looking_nation" options={nation} name="nation" placeholder="Nationality" /> : ''}
                    </div>
                    <span className='error_msg'> {errors.nation?.type === 'required' && "Please  select nationality"}</span>
                    <Form.Select {...register("country")} onChange={(e) => handleState(e)} aria-label="Default select example" className="looking_dropdown mt-3" required>
                        <option value="" disabled >Living in</option>
                        {details && details.length > 0 ? details[0].country.map((data, i) => {
                            return (
                                <option key={i} value={data.country_id}>{data.country_name}</option>
                            )
                        }) : ''}
                    </Form.Select>
                    {states && countrySelected ? <Form.Select {...register("state")} aria-label="Default select example" className="looking_dropdown" required>
                        <option value="" disabled >State</option>
                        {states && states.length > 0 ? states.map((data, i) => {
                            return (
                                <option key={i} value={data.state_id}>{data.state_name}</option>
                            )
                        }) : ''}
                    </Form.Select> : ""}
                    <span className='error_msg'> {errors.country?.type === 'required' && "Please  select country"}</span>
                    <span className='error_msg'> {errors.state?.type === 'required' && "Please  select state"}</span>

                    <Form.Select {...register("occupation")} aria-label="Default select example" className="looking_dropdown" required>
                        <option value="" disabled >Occupation</option>
                        {details && details.length > 0 ? details[0].occupation.map((data, i) => {
                            return (
                                <option key={i} value={data.occupation_id}>{data.occupation_name}</option>
                            )
                        }) : ''}
                    </Form.Select>
                    <span className='error_msg'> {errors.occupation?.type === 'required' && "Please  select occupation"}</span>
                    <div className="d-flex justify-content-between">
                        <div className="col-5 looking_hw">
                            <label className="mt-3">My Height</label>
                            <Form.Select {...register("height")} aria-label="Default select example" className="looking_dropdown looking_hwp mt-1" required>
                                <option value="" disabled >Height</option>
                                {details && details.length > 0 ? details[0].heights.map((data, i) => {
                                    // console.log(data)
                                    return (
                                        <option key={i} value={data.id}>{data.height}{data.unit}</option>
                                    )
                                }) : ''}
                            </Form.Select>
                            <span className='error_msg'> {errors.height?.type === 'required' && "Please select height"}</span>
                        </div>
                        <div className="col-5 looking_hw">
                            <label className="mt-3">My Weight</label>
                            <Form.Select {...register("weight")} aria-label="Default select example" className="looking_dropdown looking_hwp mt-1" required>feet
                                <option value="" disabled >Weight</option>
                                {details && details.length > 0 ? details[0].weights.map((data, i) => {
                                    // console.log(data)
                                    return (
                                        <option key={i} value={data.id}>{data.weight}</option>
                                    )
                                }) : ''}
                            </Form.Select>
                            <span className='error_msg'> {errors.weight?.type === 'required' && "Please select weight"}</span>
                        </div>
                    </div>
                    <label className="mt-3">Education (optional)</label>
                    <div className="form-check px-0" id="activeweights" >
                        {details && details.length > 0 ? details[0].studies.map((data, i) => {
                            // console.log(data)
                            return (
                                <label key={i} className="custom-checkbox">
                                    <input {...register("education")} className="getmore custom-checkbox-input" value={data.study_id} type="radio" />
                                    <span className="custom-checkbox-text">{data.study_name}</span>
                                </label>
                            )
                        }) : ''}
                    </div>
                    <Form.Select {...register("religion")} aria-label="Default select example" className="looking_dropdown mt-3" required>
                        <option value="" disabled >Religion</option>
                        {details && details.length > 0 ? details[0].religion.map((data, i) => {
                            return (
                                <option key={i} value={data.religion_id}>{data.religion_name}</option>
                            )
                        }) : ''}
                    </Form.Select>
                    <span className='error_msg'> {errors.religion?.type === 'required' && "Please  select religion"}</span>
                    <Form.Control {...register("caste")} type="text" placeholder="Caste (optional)" className="caste_field" />
                    <label className="mt-3">Smokes</label>
                    <div className="form-check px-0" id="activeweights" >
                        {details && details.length > 0 ? details[0].smoke.map((data, i) => {
                            return (
                                <label key={i} className="custom-checkbox">
                                    <input {...register("smoke")} className="getmore custom-checkbox-input" name='smoke' value={data.id} type="radio" />
                                    <span className="custom-checkbox-text">{data.name}</span>
                                </label>
                            )
                        }) : ''}<br></br>
                        <span className='error_msg'> {errors.smoke?.type === 'required' && "Please select your smoking habit"}</span>
                    </div>
                    <label className="mt-3">Drinks</label>
                    <div className="form-check px-0" id="activeweights" >
                        {details && details.length > 0 ? details[0].drink.map((data, i) => {
                            return (
                                <label className="custom-checkbox">
                                    <input {...register("drinks")} className="getmore custom-checkbox-input" value={data.id} type="radio" />
                                    <span className="custom-checkbox-text">{data.name}</span>
                                </label>
                            )
                        }) : ''}<br></br>
                        <span className='error_msg'> {errors.drinks?.type === 'required' && "Please select your alcoholic habit"}</span>
                    </div>
                    <label className="mt-3">My Diet</label>
                    <div className="form-check px-0" id="activeweights" >
                        {details && details.length > 0 ? details[0].diet.map((data, i) => {
                            return (
                                <label key={i} className="custom-checkbox">
                                    <input {...register("diet")} className="getmore custom-checkbox-input" value={data.id} type="radio" />
                                    <span className="custom-checkbox-text">{data.name}</span>
                                </label>
                            )
                        }) : ''}<br></br>
                        <span className='error_msg'> {errors.diet?.type === 'required' && "Please select diet"}</span>
                    </div>
                    <Form.Select {...register("horoscope")} aria-label="Default select example" className="looking_dropdown mt-3">
                        <option value="" disabled >Horoscope (optional)</option>
                        {details && details.length > 0 ? details[0].horoscope.map((data, i) => {
                            return (
                                <option key={i} value={data.horoscope_id}>{data.horoscope_name}</option>
                            )
                        }) : ''}
                    </Form.Select>
                    <Button variant="dark" type="submit" className="d-block m-auto mt-5 mb-3 w-100 btn_disabled" onClick={handleSubmit(onMoreSubmit)}>
                        CONTINUE
                    </Button>
                </Form>
            </div>
        </div>
    )
}
export default Moreabout;